// extracted by mini-css-extract-plugin
module.exports = {"terms-of-use":"TermsOfUse_terms-of-use__Lr3hg","page--generic":"TermsOfUse_page--generic__PJkvW"};